const EMBED_PREFIX = "https://www.google.com/maps/embed";

export function extractEmbedSrc(value) {
  const raw = (value || "").trim();
  if (!raw) return "";
  const m = raw.match(/<iframe[^>]*\ssrc=["']([^"']+)["']/i);
  return (m ? m[1] : raw).trim();
}

export function isValidMapsEmbed(url) {
  return (url || "").startsWith(EMBED_PREFIX);
}

export function sanitizeMapsEmbed(value) {
  const src = extractEmbedSrc(value);
  return isValidMapsEmbed(src) ? src : "";
}
